import Material from "./material.vue";

export default Material;
